import { ChatPanel } from '../components/ChatPanel';

export function ChatPage() {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          padding: '8px 16px',
          background: '#161b22',
          borderBottom: '1px solid #30363d',
          WebkitAppRegion: 'drag',
        }}
      >
        <h2 style={{ fontSize: 14, fontWeight: 600, color: '#c9d1d9' }}>AI Chat</h2>
        <span style={{ fontSize: 11, color: '#8b949e' }}>Powered by Ollama / Aether Host</span>
      </div>
      <div style={{ flex: 1 }}>
        <ChatPanel />
      </div>
    </div>
  );
}
